import React from 'react';

import { Box, Inline } from '@styleseat/ui';
import { BrandColor } from '@styleseat/brand';
import { QueryFilter } from '../search/QueryFilter';
import { LocationFilter } from '../search/LocationFilter';
import SearchInputModalTrigger from '../search/SearchPopover/SearchInputModalTrigger';
import Image from '../../shared/Image';

import {
  BodyText,
  Button,
  HeaderText,
  Stack,
} from '../../ui';
import { BasicSearchIcon } from '../../ui/Icons';
import PosingModelsImg from '../images/posing_model_banner.png';
import {
  Z_BG,
  Z_FG,
  Z_FORCE_BG,
  Z_FORCE_FG,
} from '../../ui/utilities/zIndex';
import { HomeHeroProps } from './types';

export const HomeHero = ({
  showSearchPopoverTrigger,
  updateQuery,
  mobileLayout,
  canShowSubscriptionFeatures,
  goToJoinPage,
  displayQ,
  locationRef,
  location,
  updateLocation,
  handleSearchPopoverClose,
  handleShortSubmitClick,
  handleQueryBlur,
  breakpoints,
  isIpadWidthOrLess,
}: HomeHeroProps) => {
  let boxHeight = 392;
  let leftBoxWidth;
  if ((breakpoints.desktopNarrow || breakpoints.tablet) && !mobileLayout) {
    leftBoxWidth = '60%';
    boxHeight = 280;
  } else if (isIpadWidthOrLess && !mobileLayout) {
    boxHeight = 392;
    leftBoxWidth = '57%';
  } else if (breakpoints.desktop || breakpoints.wide) {
    leftBoxWidth = '54%';
    boxHeight = 425;
  } else {
    leftBoxWidth = '100%';
  }

  const imageSize = { width: 600, height: 424 };

  if (breakpoints.desktopNarrow || breakpoints.tablet) {
    imageSize.width = 387;
    imageSize.height = 279;
  } else if (isIpadWidthOrLess) {
    imageSize.height = 372;
    imageSize.width = 520;
  }

  return (
    <Inline
      testID="home-hero-container"
      color={BrandColor.Bone}
      height={mobileLayout ? undefined : boxHeight}
      position="relative"
      space={12}
      alignItems="center"
      justifyContent="stretch"
      zIndex={Z_FG}
    >
      <Stack
        justifyContent="space-between"
        flexGrow={1}
        height="100%"
        padding={24}
      >
        <Stack
          flexGrow={1}
          justifyContent="center"
          alignItems="stretch"
          width={leftBoxWidth as `${number}%`}
          zIndex={Z_FORCE_FG}
        >
          <Stack
            justifyContent="center"
            alignItems="center"
            space={28}
          >
            <Stack testID="home-hero-title-container" space={isIpadWidthOrLess ? 4 : 12}>
              <HeaderText
                level={1}
                textAlign="center"
                fontSize={!isIpadWidthOrLess ? 36 : undefined}
              >
                Discover &amp; book local
              </HeaderText>
              <HeaderText
                level={1}
                textAlign="center"
                fontSize={!isIpadWidthOrLess ? 36 : undefined}
              >
                beauty professionals
              </HeaderText>
            </Stack>
            <Box
              testID="home-hero-search-container"
              width="100%"
              zIndex={Z_FORCE_FG}
              maxWidth={showSearchPopoverTrigger ? 350 : 500}
            >
              {showSearchPopoverTrigger ? (
                <Box
                  alignItems="stretch"
                  color={BrandColor.WhiteWash}
                  justifyContent="stretch"
                  padding={8}
                  borderRadius={100}
                  width={mobileLayout ? '100%' : undefined}
                >
                  <SearchInputModalTrigger source="home_hero" useAlternativeStyle />
                </Box>

              ) : (
                <Inline
                  alignItems="center"
                  color={BrandColor.WhiteWash}
                  space={8}
                  padding={8}
                  borderRadius={100}
                >
                  <QueryFilter
                    setQuery={updateQuery}
                    onClosePopover={handleSearchPopoverClose}
                    query={displayQ || ''}
                    showSearchButton={false}
                    onBlur={handleQueryBlur}
                  />
                  <Box style={{
                    width: 1,
                    height: 32,
                    backgroundColor: BrandColor.BackInBlack,
                  }}
                  />
                  <LocationFilter
                    ref={locationRef}
                    address={location.address || ''}
                    updateLocation={updateLocation}
                  />
                  <Button
                    size="large"
                    appearance="primary"
                    onClick={handleShortSubmitClick}
                    testID="search"
                    style={{
                      display: 'flex',
                      padding: 8,
                      borderRadius: 32,
                      position: 'absolute',
                      right: 8,
                    }}
                  >
                    <BasicSearchIcon color={BrandColor.WhiteWash} />
                  </Button>
                </Inline>
              )}
            </Box>
          </Stack>
        </Stack>
        {(!mobileLayout && canShowSubscriptionFeatures) && (
          <Inline
            testID="home-hero-grow-your-business-container"
            justifyContent="center"
            alignItems="center"
            space={8}
            width={leftBoxWidth as `${number}%`}
            zIndex={Z_BG}
          >
            <BodyText
              appearance="normal"
              weight="bold"
            >
              Grow your business with StyleSeat
            </BodyText>
            <Button
              size="small"
              appearance="primary-neue"
              onClick={goToJoinPage}
              testID="home-hero-set-up-my-business-button"
              style={{
                display: 'flex',
                borderRadius: 4,
                background: BrandColor.Green,
                color: BrandColor.WhiteWash,
              }}
            >
              Set up my business
            </Button>
          </Inline>
        )}
        {(!mobileLayout) && (
          <Box
            alignItems="stretch"
            justifyContent="stretch"
            height="100%"
            width="100%"
            position="absolute"
            left={0}
            bottom={0}
            zIndex={Z_FORCE_BG}
          >
            <Image
              source={PosingModelsImg}
              accessibilityLabel="photograph of models posing"
              style={{
                resizeMode: 'cover',
                height: imageSize.height,
                width: imageSize.width,
                right: 0,
                bottom: 0,
                position: 'absolute',
              }}
            />

          </Box>
        )}
      </Stack>
    </Inline>
  );
};
